<template>
  <div class="s-buy-count" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnBuy.src" :src="btnBuy.src" :style="{...btnBuy.style}" alt="" @click="buyFun(totalAward[0])">
    <SVersionModalCounter ref="SVersionModalCounter"></SVersionModalCounter>
  </div>
</template>

<script>

import SAnimateImage from '../AnimateImage/index.vue'
import { getLimit } from "@/components/BuilderComponents/utils";
import SVersionModalCounter from './_components/VersionModalCounter.vue'
export default {
  name: 'SVersionBuyCount',
  components: { SVersionModalCounter, SAnimateImage },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnBuy: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  mounted () {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.getCheckStatus)
      // 登出操作添加
      this.eventBus.on('signOut', this.reset)
    }
    this.getCheckStatus();
  },
  data () {
    return {
      totalAward: []
    }
  },
  methods: {
    getCheckStatus () {
      // 判断登录
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId }
      }).then((res) => {
        this.totalAward = res.groups
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    reset () {
    },
    // 点击立即购买代币
    buyFun (item) {
      // 判断登录
      if (!window.$checkLogin()) return
      /* this.$MainWrap.openVersionDialogTip({
        title: '提示',
        content: '是否消耗点券购买' + this.totalAward[0].name,
        btnConfirmText: '确定',
        btnCancelText: '取消',
        onConfirm: () => {
          this.confirmBuy(this.totalAward)
        },
        onCancel: () => {}
      }) */
      /* const leftNum = (getLimit(item.limit_single).limit - item.acquired_amount) || 0
      if (leftNum <= 0) {
        this.$message.warning('已达到限购数量')
        return
      } */
      this.$refs.SVersionModalCounter.open({
        title: '购买数量',
        initNum: 1,
        min: 1,
        // max: leftNum || 9999,
        max: 9999,
        step: 1,
        unitPrice: item.price,
        confirmBtnText: '购买',
        onConfirm: (num, price) => {
          this.$MainWrap.openVersionDialogTip({
            title: '提示',
            content: `是否消耗 ${price} 点券购买` + item.materials[0].name + '*' + ` ${num} ` + '？',
            btnConfirmText: '确定',
            btnCancelText: '取消',
            onConfirm: () => {
              this.confirmBuy(this.totalAward, num)
            },
            onCancel: () => {}
          })
        }
      })
    },
    // 确认购买信息
    confirmBuy (items, num) {
      this.requestAPI({
        url: '/v1/uni/receive',
        method: 'get',
        params: { a_id: this.activityId, g_id: items[0].id, amount: num }
      }).then((res) => {
        if (res.gift.materials.length <= 0) {
          return
        }
        const content = res.gift.materials[0].name + '*' + num
        this.$MainWrap.openVersionDialogTip({
          title: '提示',
          content: '恭喜您获得' + ' ' + content,
          btnConfirmText: '确定',
          btnCancelText: '',
          onConfirm: () => {},
          onCancel: () => {}
        })
        // 刷新代币
        this.$MainWrap.init && this.$MainWrap.init();
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.s-buy-count{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
